// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"89abd444","455":"ef90ccad","977":"eeec9405"}[chunkId] + ".chunk.js";
};